import React from 'react';
import PaymentStateScreen from './PaymentStateScreen';

const InvalidOrderScreen: React.FC<{ message?: string }> = ({ message }) => (
    <PaymentStateScreen
        title="유효하지 않은 주문이에요"
        description={message || '주문 정보를 찾을 수 없거나 유효시간이 지났어요. 앱에서 다시 시도해 주세요.'}
        isError
    />
);

export default InvalidOrderScreen;
